import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Discharge Date:</span></td>
                        <td className='w-375'><span className='eleHeader'>Admission Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDischargeDate" name="txtDischargeDate" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtAdmissionDate" name="txtAdmissionDate" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>A). Living Situation at Time of Discharge</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_1" name="cbLivingSituation_1" className='add-only' value="LivingSituation_1" />Private Residence
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_2" name="cbLivingSituation_2" className='add-only' value="LivingSituation_2" />Homeless Shelter
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_3" name="cbLivingSituation_3" className='add-only' value="LivingSituation_3" />Homeless Not In Shelter
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_4" name="cbLivingSituation_4" className='add-only' value="LivingSituation_4" />Jail/Correctional Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_5" name="cbLivingSituation_5" className='add-only' value="LivingSituation_5" />Foster Home
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_6" name="cbLivingSituation_6" className='add-only' value="LivingSituation_6" />Residential Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_7" name="cbLivingSituation_7" className='add-only' value="LivingSituation_7" />Institutional Care/Nursing Home
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_8" name="cbLivingSituation_8" className='add-only' value="LivingSituation_8" />Psychiatric Residential Treatment Facility (PRTF)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLivingSituation_9" name="cbLivingSituation_9" className='add-only' value="LivingSituation_9" />Other:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLivingSituation_9" name="txtLivingSituation_9" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>At Risk of Homelessness?</span>
                            <input type="radio" id="rbRiskHomelessness_Yes" name="rbRiskHomelessness" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbRiskHomelessness_No" name="rbRiskHomelessness" className='add-only' value="No" /> No
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>B). Services Provided </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            N/A
                            <input type="checkbox" id="cbServicesProvidedNa" name="cbServicesProvidedNa" className='add-only' value="ServicesProvidedNa" />
                            No services provided
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_1" name="cbServicesProvided_1" className='add-only' value="ServicesProvided_1" />Intensive Family Intervention (IFI)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_2" name="cbServicesProvided_2" className='add-only' value="ServicesProvided_2" />PP Community Support Individual (H2015)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_3" name="cbServicesProvided_3" className='add-only' value="ServicesProvided_3" />Individual Therapy (90832, 90834, 90837)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_4" name="cbServicesProvided_4" className='add-only' value="ServicesProvided_4" />Family Therapy (90846, 90847, H0004)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_5" name="cbServicesProvided_5" className='add-only' value="ServicesProvided_5" />PP Adult Individual Skills Training (H2017)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_6" name="cbServicesProvided_6" className='add-only' value="ServicesProvided_6" />Family Skills Training (H2014)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_7" name="cbServicesProvided_7" className='add-only' value="ServicesProvided_7" />Case Management (T1016) Medicaid Only
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_8" name="cbServicesProvided_8" className='add-only' value="ServicesProvided_8" />Peer Support Services (H0038, H0038HQ)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_9" name="cbServicesProvided_9" className='add-only' value="ServicesProvided_9" />Group Therapy (H0004HQ) Adult Medicaid Only
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbServicesProvided_10" name="cbServicesProvided_10" className='add-only' value="ServicesProvided_10" />Medication Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbServicesProvided_11" name="cbServicesProvided_11" className='add-only' value="ServicesProvided_11" />Addictive Disease Support Services (H2015HF) Adult Medicaid Only - Requested only if SA dx is present
                        </td>
                    </tr>
                </table>
                <h3>C. SNAP: STRENGTHS, NEEDS, ABILITIES, PREFERENCES</h3>
                <p>
                    <span className='eleHeader'>What strengths does the Individual have that affects their quality of life?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id="txtSnapStrengths" name="txtSnapStrengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What is needed to increase the Individual's quality of life?</span>
                    <span className='small'>(Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id="txtSnapNeed" name="txtSnapNeed" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual's abilities and skills that would help increase his/her quality of life?</span>
                    <span className='small'>(This should include personality traits, work skills, academic skills)</span>
                    <textarea id="txtSnapAbilities" name="txtSnapAbilities" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What are the Individual and family's expectation of and preferences for this service?</span>
                    <span className='small'>(This should include the Individual's own words of his/her expected outcome)</span>
                    <textarea id="txtSnapPrefrences" name="txtSnapPrefrences" className='add-only'></textarea>
                </p>
                <h3>D). Transition/Discharge</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Reason for ending service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_1" name="cbReasonEndingService_1" className='add-only' value="ReasonEndingService_1" />Treatment Completed (No Follow-Up)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_2" name="cbReasonEndingService_2" className='add-only' value="ReasonEndingService_2" />Treatment Completed (Follow-Up Required)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_3" name="cbReasonEndingService_3" className='add-only' value="ReasonEndingService_3" />Administrative Discharge
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_4" name="cbReasonEndingService_4" className='add-only' value="ReasonEndingService_4" />Further Treatment Needed (No Referral Available)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_5" name="cbReasonEndingService_5" className='add-only' value="ReasonEndingService_5" />Administrative or Medical Disqualification
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_6" name="cbReasonEndingService_6" className='add-only' value="ReasonEndingService_6" />Transfer or Referral Out of State
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_7" name="cbReasonEndingService_7" className='add-only' value="ReasonEndingService_7" />Individual Withdrew
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_8" name="cbReasonEndingService_8" className='add-only' value="ReasonEndingService_8" />Individual Incarcerated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_9" name="cbReasonEndingService_9" className='add-only' value="ReasonEndingService_9" />Other Discontinuation by Individual
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_10" name="cbReasonEndingService_10" className='add-only' value="ReasonEndingService_10" />Death (Drug or Alcohol Related)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_11" name="cbReasonEndingService_11" className='add-only' value="ReasonEndingService_11" />Death (Other Causes)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_12" name="cbReasonEndingService_12" className='add-only' value="ReasonEndingService_12" />Death (Suicide)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_13" name="cbReasonEndingService_13" className='add-only' value="ReasonEndingService_13" />Individual Moved
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_14" name="cbReasonEndingService_14" className='add-only' value="ReasonEndingService_14" />Leave of Absence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbReasonEndingService_15" name="cbReasonEndingService_15" className='add-only' value="ReasonEndingService_15" />Further Treatment Needed (Referred to Other Provider)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbReasonEndingService_16" name="cbReasonEndingService_16" className='add-only' value="ReasonEndingService_16" />Other:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtReasonEndingService_16" name="txtReasonEndingService_16" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <h3>E). Goal Progress/Status: (Pls only comment on non-generic goals) </h3>
                <p>
                    <span className='eleHeader'>What progress was made on Goal 1?</span>
                    <textarea id="txtProgressGoal_1" name="txtProgressGoal_1" className='add-only'></textarea>
                </p>
                <p>
                    Reasons for lack of progress on this goal:
                    <input type="checkbox" id="cbNoProgress_1" name="cbNoProgress_1" className='add-only' value="NoProgress" />No progress
                </p>
                <p>
                    <textarea id="txtReasonsProgress_1" name="txtReasonsProgress_1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What progress was made on Goal 2?</span>
                    <textarea id="txtProgressGoal_2" name="txtProgressGoal_2" className='add-only'></textarea>
                </p>
                <p>
                    Reasons for lack of progress on this goal:
                    <input type="checkbox" id="cbNoProgress_2" name="cbNoProgress_2" className='add-only' value="NoProgress" />No progress
                </p>
                <p>
                    <textarea id="txtReasonsProgress_2" name="txtReasonsProgress_2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What progress was made on Goal 3?</span>
                    <textarea id="txtProgressGoal_3" name="txtProgressGoal_3" className='add-only'></textarea>
                </p>
                <p>
                    Reasons for lack of progress on this goal:
                    <input type="checkbox" id="cbNoProgress_3" name="cbNoProgress_3" className='add-only' value="NoProgress" />No progress
                </p>
                <p>
                    <textarea id="txtReasonsProgress_3" name="txtReasonsProgress_3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>What progress was made on Goal 4?</span>
                    <textarea id="txtProgressGoal_4" name="txtProgressGoal_4" className='add-only'></textarea>
                </p>
                <p>
                    Reasons for lack of progress on this goal:
                    <input type="checkbox" id="cbNoProgress_4" name="cbNoProgress_4" className='add-only' value="NoProgress" />No progress
                </p>
                <p>
                    <textarea id="txtReasonsProgress_4" name="txtReasonsProgress_4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Outcome of Goals/Objectives: (achievements):</span>
                    <span className='small'>(Indicate what has been archived in the planned transition of assessment)</span>
                    <textarea id="txtOutcomeGoals" name="txtOutcomeGoals" className='add-only'></textarea>
                </p>
                <h3>F). Transition/Discharge Service Recommendations:</h3>
                <p>
                    <span className='small'>(Referrals made by Agency Ony)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_1" name="cbTransitionDischarge_1" className='add-only' value="TransitionDischarge_1" />Private Practice/MH Professional
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_2" name="cbTransitionDischarge_2" className='add-only' value="TransitionDischarge_2" />Clergy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_3" name="cbTransitionDischarge_3" className='add-only' value="TransitionDischarge_3" />Other Medical Facility
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_4" name="cbTransitionDischarge_4" className='add-only' value="TransitionDischarge_4" />Other Social Service Agencies
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_5" name="cbTransitionDischarge_5" className='add-only' value="TransitionDischarge_5" />School System
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_6" name="cbTransitionDischarge_6" className='add-only' value="TransitionDischarge_6" />ICF/MR Placement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_7" name="cbTransitionDischarge_7" className='add-only' value="TransitionDischarge_7" />Private Inpatient Facility
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_8" name="cbTransitionDischarge_8" className='add-only' value="TransitionDischarge_8" />Vocational/Job Related Agency
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_9" name="cbTransitionDischarge_9" className='add-only' value="TransitionDischarge_9" />Other DBHDD Community Program
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_10" name="cbTransitionDischarge_10" className='add-only' value="TransitionDischarge_10" />Public Inpatient Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_11" name="cbTransitionDischarge_11" className='add-only' value="TransitionDischarge_11" />Non-Psychiatric Physician
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_12" name="cbTransitionDischarge_12" className='add-only' value="TransitionDischarge_12" />Nursing/Personal Care Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_13" name="cbTransitionDischarge_13" className='add-only' value="TransitionDischarge_13" />Self-Help Organization
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_14" name="cbTransitionDischarge_14" className='add-only' value="TransitionDischarge_14" />PRTF/Match Placement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTransitionDischarge_15" name="cbTransitionDischarge_15" className='add-only' value="TransitionDischarge_15" />Other: (Pls specify)
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtTransitionDischarge_15" name="txtTransitionDischarge_15" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Summary: </span>
                    <textarea id="txtSummary" name="txtSummary" className='add-only'></textarea>
                </p>
                <h3>G1). CANS/ANSA Section (ADULT ONLY)-</h3>
                <p><span className='small'>(Pls skip section for Private insurances)</span></p>
                <p>
                    <strong>ADULT NEEDS AND STRENGTHS ASSESSMENT (ANSA) 18YRS+</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>LIFE DOMAIN FUNCTIONING </span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-625'>
                            0 = no evidence of problems, &nbsp;
                            1 = history, mild, &nbsp;
                            2 = moderate, &nbsp;
                            3 = severe
                        </td>
                    </tr>
                    <tr>
                        <td colspan="750"> &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>Physical/Medical </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_1" name="rbLifeDomain_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_1" name="rbLifeDomain_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_1" name="rbLifeDomain_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_1" name="rbLifeDomain_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Family Functioning </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_2" name="rbLifeDomain_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_2" name="rbLifeDomain_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_2" name="rbLifeDomain_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_2" name="rbLifeDomain_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Employment1 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomainNa_3" name="rbLifeDomain_3" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_3" name="rbLifeDomain_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_3" name="rbLifeDomain_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_3" name="rbLifeDomain_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_3" name="rbLifeDomain_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Social Functioning </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_4" name="rbLifeDomain_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_4" name="rbLifeDomain_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_4" name="rbLifeDomain_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_4" name="rbLifeDomain_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Recreational </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_5" name="rbLifeDomain_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_5" name="rbLifeDomain_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_5" name="rbLifeDomain_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_5" name="rbLifeDomain_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Intellectual/Developmental2 </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_6" name="rbLifeDomain_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_6" name="rbLifeDomain_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_6" name="rbLifeDomain_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_6" name="rbLifeDomain_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Sexuality </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_7" name="rbLifeDomain_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_7" name="rbLifeDomain_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_7" name="rbLifeDomain_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_7" name="rbLifeDomain_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Independent Living Skills </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_8" name="rbLifeDomain_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_8" name="rbLifeDomain_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_8" name="rbLifeDomain_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_8" name="rbLifeDomain_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Residential Stability </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_9" name="rbLifeDomain_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_9" name="rbLifeDomain_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_9" name="rbLifeDomain_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_9" name="rbLifeDomain_9" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Legal </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_10" name="rbLifeDomain_10" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_10" name="rbLifeDomain_10" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_10" name="rbLifeDomain_10" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_10" name="rbLifeDomain_10" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Sleep </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_11" name="rbLifeDomain_11" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_11" name="rbLifeDomain_11" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_11" name="rbLifeDomain_11" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_11" name="rbLifeDomain_11" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Self Care </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_12" name="rbLifeDomain_12" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_12" name="rbLifeDomain_12" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_12" name="rbLifeDomain_12" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_12" name="rbLifeDomain_12" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Decision-making </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_13" name="rbLifeDomain_13" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_13" name="rbLifeDomain_13" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_13" name="rbLifeDomain_13" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_13" name="rbLifeDomain_13" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Natural Supports </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_14" name="rbLifeDomain_14" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_14" name="rbLifeDomain_14" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_14" name="rbLifeDomain_14" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_14" name="rbLifeDomain_14" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Resiliency </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_15" name="rbLifeDomain_15" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_15" name="rbLifeDomain_15" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_15" name="rbLifeDomain_15" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_15" name="rbLifeDomain_15" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Resourcefulness </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain0_16" name="rbLifeDomain_16" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain1_16" name="rbLifeDomain_16" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain2_16" name="rbLifeDomain_16" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLifeDomain3_16" name="rbLifeDomain_16" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>ACCULTURATION </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            0 = no evidence, &nbsp;	1 = minimal needs, &nbsp; 2 = moderate needs, &nbsp;	3 = severe needs
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>Language </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation0_1" name="rbAcculturation_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation1_1" name="rbAcculturation_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation2_1" name="rbAcculturation_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation3_1" name="rbAcculturation_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Cultural Identity </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation0_2" name="rbAcculturation_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation1_2" name="rbAcculturation_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation2_2" name="rbAcculturation_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation3_2" name="rbAcculturation_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Ritual </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation0_3" name="rbAcculturation_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation1_3" name="rbAcculturation_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation2_3" name="rbAcculturation_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation3_3" name="rbAcculturation_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Cultural Stress </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation0_4" name="rbAcculturation_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation1_4" name="rbAcculturation_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation2_4" name="rbAcculturation_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAcculturation3_4" name="rbAcculturation_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>BEHAVIORAL HEALTH NEEDS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            0 = no evidence	, &nbsp;
                            1 = history or sub-threshold, watch/prevent,
                            <br />
                            2 = causing problems, consistent with diagnosable disorder, &nbsp;
                            3 = causing severe/dangerous problems
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>Psychosis </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_1" name="rbHealthNeeds_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_1" name="rbHealthNeeds_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_1" name="rbHealthNeeds_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_1" name="rbHealthNeeds_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Impulse Control </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_2" name="rbHealthNeeds_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_2" name="rbHealthNeeds_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_2" name="rbHealthNeeds_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_2" name="rbHealthNeeds_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Depression </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_3" name="rbHealthNeeds_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_3" name="rbHealthNeeds_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_3" name="rbHealthNeeds_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_3" name="rbHealthNeeds_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Anxiety </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_4" name="rbHealthNeeds_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_4" name="rbHealthNeeds_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_4" name="rbHealthNeeds_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_4" name="rbHealthNeeds_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Interpersonal Problems </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_5" name="rbHealthNeeds_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_5" name="rbHealthNeeds_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_5" name="rbHealthNeeds_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_5" name="rbHealthNeeds_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Antisocial Behavior </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_6" name="rbHealthNeeds_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_6" name="rbHealthNeeds_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_6" name="rbHealthNeeds_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_6" name="rbHealthNeeds_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Adjustment to Trauma 3 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_7" name="rbHealthNeeds_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_7" name="rbHealthNeeds_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_7" name="rbHealthNeeds_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_7" name="rbHealthNeeds_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Anger Control </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_8" name="rbHealthNeeds_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_8" name="rbHealthNeeds_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_8" name="rbHealthNeeds_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_8" name="rbHealthNeeds_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Eating Disturbance </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds0_9" name="rbHealthNeeds_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds1_9" name="rbHealthNeeds_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds2_9" name="rbHealthNeeds_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbHealthNeeds3_9" name="rbHealthNeeds_9" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>RISK BEHAVIORS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            0 = no evidence, &nbsp;	1 = history, watch/prevent, &nbsp; 2 = recent, act, &nbsp;	3 = acute, act immediately
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>Suicide Risk 5 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_1" name="rbRiskBehaviors_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_1" name="rbRiskBehaviors_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_1" name="rbRiskBehaviors_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_1" name="rbRiskBehaviors_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Danger to Others 6 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_2" name="rbRiskBehaviors_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_2" name="rbRiskBehaviors_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_2" name="rbRiskBehaviors_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_2" name="rbRiskBehaviors_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Self Injurious Behavior </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_3" name="rbRiskBehaviors_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_3" name="rbRiskBehaviors_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_3" name="rbRiskBehaviors_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_3" name="rbRiskBehaviors_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Other Self Harm </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_4" name="rbRiskBehaviors_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_4" name="rbRiskBehaviors_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_4" name="rbRiskBehaviors_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_4" name="rbRiskBehaviors_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Exploitation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_5" name="rbRiskBehaviors_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_5" name="rbRiskBehaviors_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_5" name="rbRiskBehaviors_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_5" name="rbRiskBehaviors_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Gambling </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_6" name="rbRiskBehaviors_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_6" name="rbRiskBehaviors_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_6" name="rbRiskBehaviors_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_6" name="rbRiskBehaviors_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Sexual Aggression 7 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_7" name="rbRiskBehaviors_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_7" name="rbRiskBehaviors_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_7" name="rbRiskBehaviors_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_7" name="rbRiskBehaviors_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Criminal Behavior 8 </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors0_8" name="rbRiskBehaviors_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors1_8" name="rbRiskBehaviors_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors2_8" name="rbRiskBehaviors_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRiskBehaviors3_8" name="rbRiskBehaviors_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>Substance Use </span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>

                    <tr>
                        <td colspan="5">
                            0 = no evidence, &nbsp;	1 = history, watch/prevent, &nbsp; 2 = recent, act, &nbsp;	3 = acute, act immediately
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>Substance Use </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_1" name="rbSubstanceUse_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_1" name="rbSubstanceUse_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_1" name="rbSubstanceUse_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_1" name="rbSubstanceUse_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Severity of Use </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_2" name="rbSubstanceUse_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_2" name="rbSubstanceUse_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_2" name="rbSubstanceUse_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_2" name="rbSubstanceUse_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Duration of Use </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_3" name="rbSubstanceUse_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_3" name="rbSubstanceUse_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_3" name="rbSubstanceUse_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_3" name="rbSubstanceUse_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Peer Influences </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_4" name="rbSubstanceUse_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_4" name="rbSubstanceUse_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_4" name="rbSubstanceUse_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_4" name="rbSubstanceUse_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Environmental Influences </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_5" name="rbSubstanceUse_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_5" name="rbSubstanceUse_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_5" name="rbSubstanceUse_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_5" name="rbSubstanceUse_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Recovery Support in Community </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_6" name="rbSubstanceUse_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_6" name="rbSubstanceUse_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_6" name="rbSubstanceUse_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_6" name="rbSubstanceUse_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Stage of Recovery </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_7" name="rbSubstanceUse_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_7" name="rbSubstanceUse_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_7" name="rbSubstanceUse_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_7" name="rbSubstanceUse_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Involvement in Recovery </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_8" name="rbSubstanceUse_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_8" name="rbSubstanceUse_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_8" name="rbSubstanceUse_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_8" name="rbSubstanceUse_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Transportation </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_9" name="rbSubstanceUse_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_9" name="rbSubstanceUse_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_9" name="rbSubstanceUse_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_9" name="rbSubstanceUse_9" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Medication Compliance </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_10" name="rbSubstanceUse_10" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_10" name="rbSubstanceUse_10" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_10" name="rbSubstanceUse_10" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_10" name="rbSubstanceUse_10" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Parental/Caregiver Role </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUseNa_11" name="rbSubstanceUse_11" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse0_11" name="rbSubstanceUse_11" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse1_11" name="rbSubstanceUse_11" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse2_11" name="rbSubstanceUse_11" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUse3_11" name="rbSubstanceUse_11" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>STRENGTHS </span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            0 = centerpiece, &nbsp;	1 = useful, &nbsp; 2 = identified, &nbsp;	3 = not yet identified
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>Family </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_1" name="rbStrengths_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_1" name="rbStrengths_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_1" name="rbStrengths_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_1" name="rbStrengths_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Social Connectedness </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_2" name="rbStrengths_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_2" name="rbStrengths_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_2" name="rbStrengths_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_2" name="rbStrengths_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Optimism </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_3" name="rbStrengths_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_3" name="rbStrengths_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_3" name="rbStrengths_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_3" name="rbStrengths_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Talents/Interests </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_4" name="rbStrengths_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_4" name="rbStrengths_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_4" name="rbStrengths_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_4" name="rbStrengths_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Educational </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengthsNa_5" name="rbStrengths_5" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_5" name="rbStrengths_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_5" name="rbStrengths_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_5" name="rbStrengths_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_5" name="rbStrengths_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Volunteering </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_6" name="rbStrengths_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_6" name="rbStrengths_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_6" name="rbStrengths_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_6" name="rbStrengths_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Job History </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_7" name="rbStrengths_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_7" name="rbStrengths_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_7" name="rbStrengths_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_7" name="rbStrengths_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Spiritual/Religious </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_8" name="rbStrengths_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_8" name="rbStrengths_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_8" name="rbStrengths_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_8" name="rbStrengths_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Community Connection </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths0_9" name="rbStrengths_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths1_9" name="rbStrengths_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths2_9" name="rbStrengths_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbStrengths3_9" name="rbStrengths_9" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>Optional CAREGIVER STRENGTHS & NEEDS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            X Not applicable - no caregiver identified
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            0 = no evidence &nbsp;	1 = minimal needs &nbsp; 2 = moderate needs &nbsp;	3 = severe needs
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'>Physical/Behavioral Health </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_1" name="rbOptionalCaregiver_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_1" name="rbOptionalCaregiver_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_1" name="rbOptionalCaregiver_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_1" name="rbOptionalCaregiver_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Involvement </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_2" name="rbOptionalCaregiver_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_2" name="rbOptionalCaregiver_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_2" name="rbOptionalCaregiver_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_2" name="rbOptionalCaregiver_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Knowledge </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_3" name="rbOptionalCaregiver_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_3" name="rbOptionalCaregiver_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_3" name="rbOptionalCaregiver_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_3" name="rbOptionalCaregiver_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Social Resources </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_4" name="rbOptionalCaregiver_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_4" name="rbOptionalCaregiver_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_4" name="rbOptionalCaregiver_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_4" name="rbOptionalCaregiver_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Family Stress </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_5" name="rbOptionalCaregiver_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_5" name="rbOptionalCaregiver_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_5" name="rbOptionalCaregiver_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_5" name="rbOptionalCaregiver_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Safety </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver0_6" name="rbOptionalCaregiver_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver1_6" name="rbOptionalCaregiver_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver2_6" name="rbOptionalCaregiver_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalCaregiver3_6" name="rbOptionalCaregiver_6" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Modules</strong>
                </p>
                <ul>
                    <li>1 go to Vocational/Career Module</li>
                    <li>2 go to DD Module</li>
                    <li>3 go to Trauma Module</li>
                    <li>4 go to Suicide Module</li>
                    <li>5 go to Dangerousness Module</li>
                    <li>6 go to Sex Offender Module</li>
                    <li>7 go to Crime Module</li>
                </ul>
                <p>
                    Shaded ratings trigger required Extension Modules on next page.
                </p>
                <p>
                    <strong>See Back for Module Scoring</strong>
                </p>
                <h3>Extension MODULES</h3>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>VOCATIONAL/CAREER </span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-625'>Career Aspirations </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_1" name="rbVocationalCareer_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_1" name="rbVocationalCareer_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_1" name="rbVocationalCareer_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_1" name="rbVocationalCareer_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Job Time </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_2" name="rbVocationalCareer_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_2" name="rbVocationalCareer_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_2" name="rbVocationalCareer_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_2" name="rbVocationalCareer_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Job Attendance  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareerNa_3" name="rbVocationalCareer_3" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_3" name="rbVocationalCareer_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_3" name="rbVocationalCareer_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_3" name="rbVocationalCareer_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_3" name="rbVocationalCareer_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>Job Performance </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareerNa_4" name="rbVocationalCareer_4" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_4" name="rbVocationalCareer_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_4" name="rbVocationalCareer_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_4" name="rbVocationalCareer_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_4" name="rbVocationalCareer_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Job Relations  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareerNa_5" name="rbVocationalCareer_5" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_5" name="rbVocationalCareer_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_5" name="rbVocationalCareer_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_5" name="rbVocationalCareer_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_5" name="rbVocationalCareer_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>Job Skills </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer0_6" name="rbVocationalCareer_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer1_6" name="rbVocationalCareer_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer2_6" name="rbVocationalCareer_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbVocationalCareer3_6" name="rbVocationalCareer_6" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>DEVELOPMENTAL NEEDS  (DD) </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Cognitive </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds0_1" name="rbDevelopmentalNeeds_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds1_1" name="rbDevelopmentalNeeds_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds2_1" name="rbDevelopmentalNeeds_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds3_1" name="rbDevelopmentalNeeds_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Communication </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds0_2" name="rbDevelopmentalNeeds_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds1_2" name="rbDevelopmentalNeeds_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds2_2" name="rbDevelopmentalNeeds_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds3_2" name="rbDevelopmentalNeeds_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Developmental </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds0_3" name="rbDevelopmentalNeeds_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds1_3" name="rbDevelopmentalNeeds_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds2_3" name="rbDevelopmentalNeeds_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalNeeds3_3" name="rbDevelopmentalNeeds_3" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>PARENTING/CAREGIVER ROLE EXTENSION MODULE </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Knowledge of Needs </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting0_1" name="rbParenting_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting1_1" name="rbParenting_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting2_1" name="rbParenting_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting3_1" name="rbParenting_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Supervision </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting0_2" name="rbParenting_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting1_2" name="rbParenting_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting2_2" name="rbParenting_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting3_2" name="rbParenting_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Involvement with Care </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting0_3" name="rbParenting_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting1_3" name="rbParenting_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting2_3" name="rbParenting_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting3_3" name="rbParenting_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Organization </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting0_4" name="rbParenting_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting1_4" name="rbParenting_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting2_4" name="rbParenting_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting3_4" name="rbParenting_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Marital/Partner Violence Home </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting0_5" name="rbParenting_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting1_5" name="rbParenting_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting2_5" name="rbParenting_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParenting3_5" name="rbParenting_5" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>TRAUMA (Characteristics of the trauma experience) </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Sexual Abuse </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_1" name="rbTrauma_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_1" name="rbTrauma_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_1" name="rbTrauma_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_1" name="rbTrauma_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Physical Abuse </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_2" name="rbTrauma_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_2" name="rbTrauma_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_2" name="rbTrauma_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_2" name="rbTrauma_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Emotional Abuse </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_3" name="rbTrauma_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_3" name="rbTrauma_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_3" name="rbTrauma_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_3" name="rbTrauma_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Medical Trauma </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_4" name="rbTrauma_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_4" name="rbTrauma_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_4" name="rbTrauma_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_4" name="rbTrauma_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Natural/Manmade Disaster </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_5" name="rbTrauma_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_5" name="rbTrauma_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_5" name="rbTrauma_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_5" name="rbTrauma_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Witness/Victim to Family Violence </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_6" name="rbTrauma_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_6" name="rbTrauma_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_6" name="rbTrauma_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_6" name="rbTrauma_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Witness/Victim to Community Violence </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma0_7" name="rbTrauma_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma1_7" name="rbTrauma_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma2_7" name="rbTrauma_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTrauma3_7" name="rbTrauma_7" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>Adjustment </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Affect Regulation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment0_1" name="rbAdjustment_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment1_1" name="rbAdjustment_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment2_1" name="rbAdjustment_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment3_1" name="rbAdjustment_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Intrusions </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment0_2" name="rbAdjustment_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment1_2" name="rbAdjustment_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment2_2" name="rbAdjustment_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment3_2" name="rbAdjustment_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Attachment </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment0_3" name="rbAdjustment_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment1_3" name="rbAdjustment_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment2_3" name="rbAdjustment_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment3_3" name="rbAdjustment_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Dissociation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment0_4" name="rbAdjustment_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment1_4" name="rbAdjustment_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment2_4" name="rbAdjustment_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustment3_4" name="rbAdjustment_4" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>SUBSTANCE USE  (SUD) </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Severity of Use </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_1" name="rbSud_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_1" name="rbSud_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_1" name="rbSud_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_1" name="rbSud_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Duration of Use </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_2" name="rbSud_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_2" name="rbSud_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_2" name="rbSud_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_2" name="rbSud_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Stage of Recovery </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_3" name="rbSud_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_3" name="rbSud_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_3" name="rbSud_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_3" name="rbSud_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Peer Influences </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_4" name="rbSud_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_4" name="rbSud_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_4" name="rbSud_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_4" name="rbSud_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Environmental Influences </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_5" name="rbSud_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_5" name="rbSud_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_5" name="rbSud_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_5" name="rbSud_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Recovery Support in Community </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud0_6" name="rbSud_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud1_6" name="rbSud_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud2_6" name="rbSud_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSud3_6" name="rbSud_6" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>SUICIDE MODULE </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Suicide Ideation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule0_1" name="rbSuicideModule_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule1_1" name="rbSuicideModule_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule2_1" name="rbSuicideModule_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule3_1" name="rbSuicideModule_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Suicide Intent </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule0_2" name="rbSuicideModule_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule1_2" name="rbSuicideModule_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule2_2" name="rbSuicideModule_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule3_2" name="rbSuicideModule_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Suicide Planning </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule0_3" name="rbSuicideModule_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule1_3" name="rbSuicideModule_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule2_3" name="rbSuicideModule_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule3_3" name="rbSuicideModule_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Suicide History </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule0_4" name="rbSuicideModule_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule1_4" name="rbSuicideModule_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule2_4" name="rbSuicideModule_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSuicideModule3_4" name="rbSuicideModule_4" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>DANGEROUSNESS MODULE </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Intent </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_1" name="rbDangerousness_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_1" name="rbDangerousness_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_1" name="rbDangerousness_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_1" name="rbDangerousness_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Planning </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_2" name="rbDangerousness_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_2" name="rbDangerousness_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_2" name="rbDangerousness_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_2" name="rbDangerousness_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Violence History </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_3" name="rbDangerousness_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_3" name="rbDangerousness_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_3" name="rbDangerousness_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_3" name="rbDangerousness_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Frustration Management </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_4" name="rbDangerousness_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_4" name="rbDangerousness_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_4" name="rbDangerousness_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_4" name="rbDangerousness_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Hostility </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_5" name="rbDangerousness_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_5" name="rbDangerousness_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_5" name="rbDangerousness_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_5" name="rbDangerousness_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Paranoid Thinking </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_6" name="rbDangerousness_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_6" name="rbDangerousness_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_6" name="rbDangerousness_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_6" name="rbDangerousness_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Secondary gains from anger </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_7" name="rbDangerousness_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_7" name="rbDangerousness_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_7" name="rbDangerousness_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_7" name="rbDangerousness_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Violent Thinking </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_8" name="rbDangerousness_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_8" name="rbDangerousness_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_8" name="rbDangerousness_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_8" name="rbDangerousness_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'></td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_9" name="rbDangerousness_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_9" name="rbDangerousness_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_9" name="rbDangerousness_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_9" name="rbDangerousness_9" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>Resiliency Factors </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr >
                        <td className='w-650'>Aware of violence potential </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_10" name="rbDangerousness_10" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_10" name="rbDangerousness_10" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_10" name="rbDangerousness_10" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_10" name="rbDangerousness_10" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Response to Consequences </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_11" name="rbDangerousness_11" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_11" name="rbDangerousness_11" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_11" name="rbDangerousness_11" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_11" name="rbDangerousness_11" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Commitment to Self-Control </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_12" name="rbDangerousness_12" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_12" name="rbDangerousness_12" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_12" name="rbDangerousness_12" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_12" name="rbDangerousness_12" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Treatment Involvement </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness0_13" name="rbDangerousness_13" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness1_13" name="rbDangerousness_13" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness2_13" name="rbDangerousness_13" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDangerousness3_13" name="rbDangerousness_13" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>SEXUALLY AGGRESSIVE BEHAVIOR (SAB) </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Relationship </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_1" name="rbSab_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_1" name="rbSab_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_1" name="rbSab_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_1" name="rbSab_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Physical Force/Threat </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_2" name="rbSab_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_2" name="rbSab_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_2" name="rbSab_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_2" name="rbSab_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Planning </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_3" name="rbSab_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_3" name="rbSab_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_3" name="rbSab_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_3" name="rbSab_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Age Differential </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_4" name="rbSab_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_4" name="rbSab_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_4" name="rbSab_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_4" name="rbSab_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Type of Sex Act </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_5" name="rbSab_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_5" name="rbSab_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_5" name="rbSab_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_5" name="rbSab_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Response to Accusation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab0_6" name="rbSab_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab1_6" name="rbSab_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab2_6" name="rbSab_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSab3_6" name="rbSab_6" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CRIME </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Seriousness </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_1" name="rbCrime_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_1" name="rbCrime_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_1" name="rbCrime_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_1" name="rbCrime_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>History </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_2" name="rbCrime_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_2" name="rbCrime_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_2" name="rbCrime_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_2" name="rbCrime_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Arrests </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_3" name="rbCrime_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_3" name="rbCrime_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_3" name="rbCrime_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_3" name="rbCrime_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Planning </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_4" name="rbCrime_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_4" name="rbCrime_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_4" name="rbCrime_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_4" name="rbCrime_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Community Safety </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_5" name="rbCrime_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_5" name="rbCrime_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_5" name="rbCrime_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_5" name="rbCrime_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Legal Compliance </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_6" name="rbCrime_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_6" name="rbCrime_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_6" name="rbCrime_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_6" name="rbCrime_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Peer Influences </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_7" name="rbCrime_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_7" name="rbCrime_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_7" name="rbCrime_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_7" name="rbCrime_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>Environmental Influences </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime0_8" name="rbCrime_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime1_8" name="rbCrime_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime2_8" name="rbCrime_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCrime3_8" name="rbCrime_8" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <h3>G2). CANS-Trauma Comprehensive - (For Child/Adolescents only)- </h3>
                <p><span className='small'>Pls skip for private insurtace</span></p>
                <p>
                    <strong>KEY for Traumatic I Adverse Childhood Experience Domain:  </strong>
                </p>
                <p>
                    o = No evidence of any trauma of this type
                    <br />
                    1 = "Mild" exposure, a single incident or suspicion of this trauma or ACE.
                    <br />
                    2 = Child experienced multiple incidents or a moderate degree of this trauma or ACE.
                    <br />
                    3 = Child experienced repeated and severe incidents of this trauma or ACE.
                </p>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>TRAUMATIC / ADVERSE CHILDHOOD EXPERIENCES</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>1. Sexual Abuse  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_1" name="rbTraumatic_1" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_1" name="rbTraumatic_1" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_1" name="rbTraumatic_1" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_1" name="rbTraumatic_1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>2. Physical Abuse   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_2" name="rbTraumatic_2" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_2" name="rbTraumatic_2" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_2" name="rbTraumatic_2" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_2" name="rbTraumatic_2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>3. Emotional Abuse   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_3" name="rbTraumatic_3" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_3" name="rbTraumatic_3" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_3" name="rbTraumatic_3" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_3" name="rbTraumatic_3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>4. Neglect   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_4" name="rbTraumatic_4" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_4" name="rbTraumatic_4" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_4" name="rbTraumatic_4" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_4" name="rbTraumatic_4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>5. Medical Trauma   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_5" name="rbTraumatic_5" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_5" name="rbTraumatic_5" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_5" name="rbTraumatic_5" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_5" name="rbTraumatic_5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>6. Family Violence   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_6" name="rbTraumatic_6" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_6" name="rbTraumatic_6" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_6" name="rbTraumatic_6" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_6" name="rbTraumatic_6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>7. Community Violence   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_7" name="rbTraumatic_7" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_7" name="rbTraumatic_7" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_7" name="rbTraumatic_7" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_7" name="rbTraumatic_7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>8. 	School Violence    </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_8" name="rbTraumatic_8" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_8" name="rbTraumatic_8" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_8" name="rbTraumatic_8" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_8" name="rbTraumatic_8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>9. Natural or Manmade Disasters  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_9" name="rbTraumatic_9" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_9" name="rbTraumatic_9" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_9" name="rbTraumatic_9" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_9" name="rbTraumatic_9" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>10. War Affected   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_10" name="rbTraumatic_10" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_10" name="rbTraumatic_10" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_10" name="rbTraumatic_10" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_10" name="rbTraumatic_10" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>11. Terrorism Affected   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_11" name="rbTraumatic_11" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_11" name="rbTraumatic_11" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_11" name="rbTraumatic_11" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_11" name="rbTraumatic_11" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>12. Witness to Criminal Activity   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_12" name="rbTraumatic_12" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_12" name="rbTraumatic_12" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_12" name="rbTraumatic_12" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_12" name="rbTraumatic_12" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>13. Parental Criminal Behavior   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_13" name="rbTraumatic_13" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_13" name="rbTraumatic_13" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_13" name="rbTraumatic_13" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_13" name="rbTraumatic_13" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>14. Disruption in Caregiving   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic0_14" name="rbTraumatic_14" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic1_14" name="rbTraumatic_14" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic2_14" name="rbTraumatic_14" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumatic3_14" name="rbTraumatic_14" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>KEY for Symptoms Related to Traumatic I Adverse Childhood Experiences Domain:   </strong>
                </p>
                <p>
                    0= No evidence of a need I no reason to believe that the rated item requires any action.
                    <br />
                    1 = A need for watchful waiting, monitoring or possibly preventive action.
                    <br />
                    2 = A need for action. Some strategy is needed to address the problem/need.
                    <br />
                    3 = A need for immediate or intensive action. This level indicates an immediate safety concern or a priority for intervention.
                </p>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>TRAUMATIC STRESS SYMPTOMS  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>15. Adjustment to Trauma   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_15" name="rbTraumaticStress_15" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_15" name="rbTraumaticStress_15" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_15" name="rbTraumaticStress_15" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_15" name="rbTraumaticStress_15" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>16. Traumatic Grief   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_16" name="rbTraumaticStress_16" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_16" name="rbTraumaticStress_16" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_16" name="rbTraumaticStress_16" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_16" name="rbTraumaticStress_16" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>17. Re-experiencing   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_17" name="rbTraumaticStress_17" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_17" name="rbTraumaticStress_17" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_17" name="rbTraumaticStress_17" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_17" name="rbTraumaticStress_17" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>18. Hyperarousal   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_18" name="rbTraumaticStress_18" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_18" name="rbTraumaticStress_18" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_18" name="rbTraumaticStress_18" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_18" name="rbTraumaticStress_18" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>19. Avoidance   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_19" name="rbTraumaticStress_19" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_19" name="rbTraumaticStress_19" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_19" name="rbTraumaticStress_19" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_19" name="rbTraumaticStress_19" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>20. Numbing   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_20" name="rbTraumaticStress_20" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_20" name="rbTraumaticStress_20" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_20" name="rbTraumaticStress_20" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_20" name="rbTraumaticStress_20" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>21. Dissociation   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_21" name="rbTraumaticStress_21" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_21" name="rbTraumaticStress_21" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_21" name="rbTraumaticStress_21" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_21" name="rbTraumaticStress_21" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>22. Affective/Physiological Dys.   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress0_22" name="rbTraumaticStress_22" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress1_22" name="rbTraumaticStress_22" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress2_22" name="rbTraumaticStress_22" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTraumaticStress3_22" name="rbTraumaticStress_22" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>CHILD STRENGTHS </span>
                </p>
                <p>
                    <strong>KEY for Strengths Domain: </strong>
                </p>
                <p>
                    o = Centerpiece strength
                    <br />
                    1 = Useful strength
                    <br />
                    2 = Identified strength
                    <br />
                    3 = Not yet identified strength I NO information about a strength in this area
                </p>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>CHILD STRENGTHS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                    </tr>
                    <tr>
                        <td className='w-625'>23. Family  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_23" name="rbChildStrengths_23" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_23" name="rbChildStrengths_23" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_23" name="rbChildStrengths_23" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_23" name="rbChildStrengths_23" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-625'>24. Interpersonal  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_24" name="rbChildStrengths_24" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_24" name="rbChildStrengths_24" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_24" name="rbChildStrengths_24" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_24" name="rbChildStrengths_24" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>25. Educational  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_25" name="rbChildStrengths_25" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_25" name="rbChildStrengths_25" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_25" name="rbChildStrengths_25" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_25" name="rbChildStrengths_25" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengthsNa_25" name="rbChildStrengths_25" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>26. Vocational  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_26" name="rbChildStrengths_26" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_26" name="rbChildStrengths_26" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_26" name="rbChildStrengths_26" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_26" name="rbChildStrengths_26" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengthsNa_26" name="rbChildStrengths_26" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>27. Coping and Savoring Skills  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_27" name="rbChildStrengths_27" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_27" name="rbChildStrengths_27" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_27" name="rbChildStrengths_27" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_27" name="rbChildStrengths_27" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-625'>28. Optimism   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_28" name="rbChildStrengths_28" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_28" name="rbChildStrengths_28" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_28" name="rbChildStrengths_28" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_28" name="rbChildStrengths_28" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>29. Talents/lnterests   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_29" name="rbChildStrengths_29" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_29" name="rbChildStrengths_29" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_29" name="rbChildStrengths_29" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_29" name="rbChildStrengths_29" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-625'>30. Spiritual/Religious   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_30" name="rbChildStrengths_30" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_30" name="rbChildStrengths_30" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_30" name="rbChildStrengths_30" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_30" name="rbChildStrengths_30" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>31. Community Life  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_31" name="rbChildStrengths_31" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_31" name="rbChildStrengths_31" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_31" name="rbChildStrengths_31" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_31" name="rbChildStrengths_31" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-625'>32. Relationship Permanence  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_32" name="rbChildStrengths_32" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_32" name="rbChildStrengths_32" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_32" name="rbChildStrengths_32" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_32" name="rbChildStrengths_32" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-625'>33. Resilience  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths0_33" name="rbChildStrengths_33" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths1_33" name="rbChildStrengths_33" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths2_33" name="rbChildStrengths_33" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbChildStrengths3_33" name="rbChildStrengths_33" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                </table>
                <p>
                    CANS-Trauma Scoring Sheet Revised: March, 2013
                    <br />
                    For use with the March, 2013 version of CANS-Trauma Comprehensive Manual
                </p>
                <p>
                    <strong>KEY for Other Need Domains: </strong>
                </p>
                <p>
                    0 = No evidence of a need I no reason to believe that the rated item requires any action.
                    <br />
                    1 = A need for watchful waiting, monitoring or possibly preventive action.
                    <br />
                    2 = A need for action. Some strategy is needed to address the problem/need.
                    <br />
                    3 = A need for immediate or intensive action. This level indicates an immediate safety concern or a priority for intervention.
                </p>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>LIFE DOMAIN FUNCTIONING  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>34. Family   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_34" name="rbDomain_34" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_34" name="rbDomain_34" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_34" name="rbDomain_34" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_34" name="rbDomain_34" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>35. Living Situation  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_35" name="rbDomain_35" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_35" name="rbDomain_35" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_35" name="rbDomain_35" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_35" name="rbDomain_35" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>36. Social Functioning  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_36" name="rbDomain_36" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_36" name="rbDomain_36" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_36" name="rbDomain_36" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_36" name="rbDomain_36" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>37. Developmental   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_37" name="rbDomain_37" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_37" name="rbDomain_37" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_37" name="rbDomain_37" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_37" name="rbDomain_37" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>38. Recreational  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_38" name="rbDomain_38" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_38" name="rbDomain_38" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_38" name="rbDomain_38" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_38" name="rbDomain_38" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>39. Legal   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_39" name="rbDomain_39" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_39" name="rbDomain_39" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_39" name="rbDomain_39" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_39" name="rbDomain_39" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>40. Medical  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_40" name="rbDomain_40" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_40" name="rbDomain_40" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_40" name="rbDomain_40" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_40" name="rbDomain_40" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>41. Physical   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_41" name="rbDomain_41" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_41" name="rbDomain_41" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_41" name="rbDomain_41" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_41" name="rbDomain_41" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>42. Sleep  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_42" name="rbDomain_42" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_42" name="rbDomain_42" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_42" name="rbDomain_42" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_42" name="rbDomain_42" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>43. Sexual Development  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_43" name="rbDomain_43" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_43" name="rbDomain_43" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_43" name="rbDomain_43" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_43" name="rbDomain_43" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>44. School Behavior  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_44" name="rbDomain_44" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_44" name="rbDomain_44" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_44" name="rbDomain_44" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_44" name="rbDomain_44" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>45. School Achievement   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_45" name="rbDomain_45" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_45" name="rbDomain_45" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_45" name="rbDomain_45" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_45" name="rbDomain_45" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>46. School Attendance   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_46" name="rbDomain_46" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_46" name="rbDomain_46" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_46" name="rbDomain_46" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_46" name="rbDomain_46" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>ACCULTURATION </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>47. Language    </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_47" name="rbDomain_47" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_47" name="rbDomain_47" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_47" name="rbDomain_47" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_47" name="rbDomain_47" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>48. Identity   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_48" name="rbDomain_48" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_48" name="rbDomain_48" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_48" name="rbDomain_48" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_48" name="rbDomain_48" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>49. Ritual    </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_49" name="rbDomain_49" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_49" name="rbDomain_49" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_49" name="rbDomain_49" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_49" name="rbDomain_49" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>50. Cultural Stress   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_50" name="rbDomain_50" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_50" name="rbDomain_50" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_50" name="rbDomain_50" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_50" name="rbDomain_50" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>&nbsp; </td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CHILD BEHAVIORAL  EMOTIONAL NEEDS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>51. Psychosis 	  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_51" name="rbDomain_51" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_51" name="rbDomain_51" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_51" name="rbDomain_51" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_51" name="rbDomain_51" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>52. Attention/Concentration   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_52" name="rbDomain_52" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_52" name="rbDomain_52" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_52" name="rbDomain_52" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_52" name="rbDomain_52" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>53. Impulsivity	  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_53" name="rbDomain_53" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_53" name="rbDomain_53" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_53" name="rbDomain_53" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_53" name="rbDomain_53" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>54. Depression 	  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_54" name="rbDomain_54" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_54" name="rbDomain_54" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_54" name="rbDomain_54" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_54" name="rbDomain_54" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>55. Anxiety   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_55" name="rbDomain_55" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_55" name="rbDomain_55" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_55" name="rbDomain_55" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_55" name="rbDomain_55" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>56. Oppositional   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_56" name="rbDomain_56" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_56" name="rbDomain_56" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_56" name="rbDomain_56" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_56" name="rbDomain_56" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>57. Conduct   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_57" name="rbDomain_57" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_57" name="rbDomain_57" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_57" name="rbDomain_57" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_57" name="rbDomain_57" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>58. Substance Use   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_58" name="rbDomain_58" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_58" name="rbDomain_58" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_58" name="rbDomain_58" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_58" name="rbDomain_58" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>59. Attachment   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_59" name="rbDomain_59" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_59" name="rbDomain_59" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_59" name="rbDomain_59" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_59" name="rbDomain_59" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>60. Eating Disturbance  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_60" name="rbDomain_60" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_60" name="rbDomain_60" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_60" name="rbDomain_60" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_60" name="rbDomain_60" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>61. Behavioral Regression   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_61" name="rbDomain_61" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_61" name="rbDomain_61" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_61" name="rbDomain_61" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_61" name="rbDomain_61" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>62. Somatization    </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_62" name="rbDomain_62" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_62" name="rbDomain_62" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_62" name="rbDomain_62" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_62" name="rbDomain_62" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>63. Anger Control  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_63" name="rbDomain_63" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_63" name="rbDomain_63" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_63" name="rbDomain_63" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_63" name="rbDomain_63" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CHILD RISK BEHAVIORS  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>64. Suicide Risk  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_64" name="rbDomain_64" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_64" name="rbDomain_64" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_64" name="rbDomain_64" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_64" name="rbDomain_64" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>65. Non-Suicidal Self-Injury  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_65" name="rbDomain_65" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_65" name="rbDomain_65" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_65" name="rbDomain_65" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_65" name="rbDomain_65" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>66. Other Self-Harm  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_66" name="rbDomain_66" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_66" name="rbDomain_66" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_66" name="rbDomain_66" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_66" name="rbDomain_66" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>67. Danger to Others  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_67" name="rbDomain_67" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_67" name="rbDomain_67" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_67" name="rbDomain_67" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_67" name="rbDomain_67" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>68. Sexual Aggression  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_68" name="rbDomain_68" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_68" name="rbDomain_68" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_68" name="rbDomain_68" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_68" name="rbDomain_68" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>69. Runaway   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_69" name="rbDomain_69" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_69" name="rbDomain_69" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_69" name="rbDomain_69" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_69" name="rbDomain_69" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>70. Delinquency   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_70" name="rbDomain_70" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_70" name="rbDomain_70" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_70" name="rbDomain_70" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_70" name="rbDomain_70" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>71. Judgment  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_71" name="rbDomain_71" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_71" name="rbDomain_71" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_71" name="rbDomain_71" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_71" name="rbDomain_71" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>72. Fire Setting  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_72" name="rbDomain_72" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_72" name="rbDomain_72" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_72" name="rbDomain_72" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_72" name="rbDomain_72" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-650'>73. Intentional Misbehavior   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_73" name="rbDomain_73" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_73" name="rbDomain_73" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_73" name="rbDomain_73" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_73" name="rbDomain_73" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>74. Sexually Reactive Behavior  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain0_74" name="rbDomain_74" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain1_74" name="rbDomain_74" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain2_74" name="rbDomain_74" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDomain3_74" name="rbDomain_74" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>RATINGS OF CHIDLREN 5 YEARS and YOUNGER - OPTIONAL DOMAIN  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                        <td className='w-25'><span className='eleHeader'>U</span></td>
                    </tr>
                    <tr>
                        <td colspan="7">
                            This domain is also meant for use developmentally delayed children of any age, and can be used with any
                            child/youth if these are areas of relevant needs regardless of child's age.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>75. Motor  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_75" name="rbOptionalDomain_75" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_75" name="rbOptionalDomain_75" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_75" name="rbOptionalDomain_75" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_75" name="rbOptionalDomain_75" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_75" name="rbOptionalDomain_75" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-600'>76. Sensory  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_76" name="rbOptionalDomain_76" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_76" name="rbOptionalDomain_76" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_76" name="rbOptionalDomain_76" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_76" name="rbOptionalDomain_76" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_76" name="rbOptionalDomain_76" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-600'>77. Communication   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_77" name="rbOptionalDomain_77" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_77" name="rbOptionalDomain_77" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_77" name="rbOptionalDomain_77" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_77" name="rbOptionalDomain_77" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_77" name="rbOptionalDomain_77" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-600'>78. Failure to Thrive   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_78" name="rbOptionalDomain_78" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_78" name="rbOptionalDomain_78" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_78" name="rbOptionalDomain_78" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_78" name="rbOptionalDomain_78" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_78" name="rbOptionalDomain_78" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-600'>79. Feeding/Elimination   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_79" name="rbOptionalDomain_79" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_79" name="rbOptionalDomain_79" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_79" name="rbOptionalDomain_79" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_79" name="rbOptionalDomain_79" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_79" name="rbOptionalDomain_79" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-600'>80. Birth Weight  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_80" name="rbOptionalDomain_80" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_80" name="rbOptionalDomain_80" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_80" name="rbOptionalDomain_80" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_80" name="rbOptionalDomain_80" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_80" name="rbOptionalDomain_80" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_80" name="rbOptionalDomain_80" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>81. Prenatal Care  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_81" name="rbOptionalDomain_81" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_81" name="rbOptionalDomain_81" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_81" name="rbOptionalDomain_81" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_81" name="rbOptionalDomain_81" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_81" name="rbOptionalDomain_81" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_81" name="rbOptionalDomain_81" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-600'>82. Substance Exposure  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_82" name="rbOptionalDomain_82" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_82" name="rbOptionalDomain_82" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_82" name="rbOptionalDomain_82" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_82" name="rbOptionalDomain_82" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_82" name="rbOptionalDomain_82" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_82" name="rbOptionalDomain_82" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>83. Labor & Delivery   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_83" name="rbOptionalDomain_83" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_83" name="rbOptionalDomain_83" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_83" name="rbOptionalDomain_83" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_83" name="rbOptionalDomain_83" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_83" name="rbOptionalDomain_83" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_83" name="rbOptionalDomain_83" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-600'>84. Parent/Sibling Problems   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_84" name="rbOptionalDomain_84" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_84" name="rbOptionalDomain_84" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_84" name="rbOptionalDomain_84" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_84" name="rbOptionalDomain_84" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_84" name="rbOptionalDomain_84" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_84" name="rbOptionalDomain_84" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>85. Availability of Caregiver  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_85" name="rbOptionalDomain_85" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_85" name="rbOptionalDomain_85" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_85" name="rbOptionalDomain_85" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_85" name="rbOptionalDomain_85" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_85" name="rbOptionalDomain_85" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainU_85" name="rbOptionalDomain_85" className='add-only' value="U" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-600'>86. Curiosity  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_86" name="rbOptionalDomain_86" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_86" name="rbOptionalDomain_86" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_86" name="rbOptionalDomain_86" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_86" name="rbOptionalDomain_86" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_86" name="rbOptionalDomain_86" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-600'>87. Playfulness   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_87" name="rbOptionalDomain_87" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_87" name="rbOptionalDomain_87" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_87" name="rbOptionalDomain_87" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_87" name="rbOptionalDomain_87" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_87" name="rbOptionalDomain_87" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr >
                        <td className='w-600'>88. Temperament 	  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_88" name="rbOptionalDomain_88" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_88" name="rbOptionalDomain_88" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_88" name="rbOptionalDomain_88" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_88" name="rbOptionalDomain_88" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_88" name="rbOptionalDomain_88" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-600'>89. Day Care Preschool   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_89" name="rbOptionalDomain_89" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_89" name="rbOptionalDomain_89" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_89" name="rbOptionalDomain_89" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_89" name="rbOptionalDomain_89" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_89" name="rbOptionalDomain_89" className='add-only' value="Na" />
                        </td>
                        <td className='w-25'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>TRANSITION TO ADULTHOOD - OPTIONAL DOMAIN  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            This domain is meant primarily for youth 14 and YJ years or older, but can be used with any child/youth if these are
                            areas of relevant needs regardless of child's age.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>90. Independent Living Skills  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_90" name="rbOptionalDomain_90" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_90" name="rbOptionalDomain_90" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_90" name="rbOptionalDomain_90" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_90" name="rbOptionalDomain_90" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_90" name="rbOptionalDomain_90" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>91. Transportation  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_91" name="rbOptionalDomain_91" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_91" name="rbOptionalDomain_91" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_91" name="rbOptionalDomain_91" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_91" name="rbOptionalDomain_91" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_91" name="rbOptionalDomain_91" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>92. Parenting Roles  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_92" name="rbOptionalDomain_92" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_92" name="rbOptionalDomain_92" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_92" name="rbOptionalDomain_92" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_92" name="rbOptionalDomain_92" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_92" name="rbOptionalDomain_92" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>93. Intimate Relationships  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_93" name="rbOptionalDomain_93" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_93" name="rbOptionalDomain_93" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_93" name="rbOptionalDomain_93" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_93" name="rbOptionalDomain_93" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_93" name="rbOptionalDomain_93" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>94. Medication Compliance   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_94" name="rbOptionalDomain_94" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_94" name="rbOptionalDomain_94" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_94" name="rbOptionalDomain_94" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_94" name="rbOptionalDomain_94" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_94" name="rbOptionalDomain_94" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>95. Education Attainment   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_95" name="rbOptionalDomain_95" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_95" name="rbOptionalDomain_95" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_95" name="rbOptionalDomain_95" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_95" name="rbOptionalDomain_95" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_95" name="rbOptionalDomain_95" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>96. Victimization   </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_96" name="rbOptionalDomain_96" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_96" name="rbOptionalDomain_96" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_96" name="rbOptionalDomain_96" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_96" name="rbOptionalDomain_96" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_96" name="rbOptionalDomain_96" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>97. Job Functioning  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain0_97" name="rbOptionalDomain_97" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain1_97" name="rbOptionalDomain_97" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain2_97" name="rbOptionalDomain_97" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomain3_97" name="rbOptionalDomain_97" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOptionalDomainNa_97" name="rbOptionalDomain_97" className='add-only' value="Na" />
                        </td>
                    </tr>
                </table>
                



                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>CAREGIVER(S) NEEDS AND STRENGTHS  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            Title/Role of Caregiver #1 (relation to child) :
                            <input type="text" id="txtCaregiverRelationToChild_1" name="txtCaregiverRelationToChild_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>98. Physical  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_98" name="rbCaregiverOne_98" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_98" name="rbCaregiverOne_98" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_98" name="rbCaregiverOne_98" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_98" name="rbCaregiverOne_98" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_98" name="rbCaregiverOne_98" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>99. Mental Health  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_99" name="rbCaregiverOne_99" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_99" name="rbCaregiverOne_99" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_99" name="rbCaregiverOne_99" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_99" name="rbCaregiverOne_99" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_99" name="rbCaregiverOne_99" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>100. Substance Use  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_100" name="rbCaregiverOne_100" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_100" name="rbCaregiverOne_100" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_100" name="rbCaregiverOne_100" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_100" name="rbCaregiverOne_100" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_100" name="rbCaregiverOne_100" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>101. Developmental  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_101" name="rbCaregiverOne_101" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_101" name="rbCaregiverOne_101" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_101" name="rbCaregiverOne_101" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_101" name="rbCaregiverOne_101" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_101" name="rbCaregiverOne_101" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>102. Supervision  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_102" name="rbCaregiverOne_102" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_102" name="rbCaregiverOne_102" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_102" name="rbCaregiverOne_102" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_102" name="rbCaregiverOne_102" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_102" name="rbCaregiverOne_102" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>103. Involvement  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_103" name="rbCaregiverOne_103" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_103" name="rbCaregiverOne_103" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_103" name="rbCaregiverOne_103" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_103" name="rbCaregiverOne_103" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_103" name="rbCaregiverOne_103" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>104. Knowledge  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_104" name="rbCaregiverOne_104" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_104" name="rbCaregiverOne_104" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_104" name="rbCaregiverOne_104" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_104" name="rbCaregiverOne_104" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_104" name="rbCaregiverOne_104" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>105. Organization  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_105" name="rbCaregiverOne_105" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_105" name="rbCaregiverOne_105" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_105" name="rbCaregiverOne_105" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_105" name="rbCaregiverOne_105" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_105" name="rbCaregiverOne_105" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>106. Resources  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_106" name="rbCaregiverOne_106" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_106" name="rbCaregiverOne_106" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_106" name="rbCaregiverOne_106" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_106" name="rbCaregiverOne_106" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_106" name="rbCaregiverOne_106" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>107. Residential Stability  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_107" name="rbCaregiverOne_107" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_107" name="rbCaregiverOne_107" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_107" name="rbCaregiverOne_107" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_107" name="rbCaregiverOne_107" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_107" name="rbCaregiverOne_107" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>108. Safety  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_108" name="rbCaregiverOne_108" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_108" name="rbCaregiverOne_108" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_108" name="rbCaregiverOne_108" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_108" name="rbCaregiverOne_108" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_108" name="rbCaregiverOne_108" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>109. Marital/Partner Violence  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_109" name="rbCaregiverOne_109" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_109" name="rbCaregiverOne_109" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_109" name="rbCaregiverOne_109" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_109" name="rbCaregiverOne_109" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_109" name="rbCaregiverOne_109" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>110. Posttraumatic Reactions  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne0_110" name="rbCaregiverOne_110" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne1_110" name="rbCaregiverOne_110" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne2_110" name="rbCaregiverOne_110" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOne3_110" name="rbCaregiverOne_110" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverOneNa_110" name="rbCaregiverOne_110" className='add-only' value="Na" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-625'><span className='eleHeader'>CAREGIVER(S) NEEDS AND STRENGTHS  </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                        <td className='w-25'><span className='eleHeader'>N/A</span></td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            Title/Role of Caregiver #2 (relation to child) :
                            <input type="text" id="txtCaregiverRelationToChild_2" name="txtCaregiverRelationToChild_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>98. Physical  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_98" name="rbCaregiverTwo_98" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_98" name="rbCaregiverTwo_98" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_98" name="rbCaregiverTwo_98" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_98" name="rbCaregiverTwo_98" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_98" name="rbCaregiverTwo_98" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>99. Mental Health  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_99" name="rbCaregiverTwo_99" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_99" name="rbCaregiverTwo_99" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_99" name="rbCaregiverTwo_99" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_99" name="rbCaregiverTwo_99" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_99" name="rbCaregiverTwo_99" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>100. Substance Use  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_100" name="rbCaregiverTwo_100" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_100" name="rbCaregiverTwo_100" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_100" name="rbCaregiverTwo_100" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_100" name="rbCaregiverTwo_100" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_100" name="rbCaregiverTwo_100" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>101. Developmental  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_101" name="rbCaregiverTwo_101" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_101" name="rbCaregiverTwo_101" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_101" name="rbCaregiverTwo_101" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_101" name="rbCaregiverTwo_101" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_101" name="rbCaregiverTwo_101" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>102. Supervision  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_102" name="rbCaregiverTwo_102" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_102" name="rbCaregiverTwo_102" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_102" name="rbCaregiverTwo_102" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_102" name="rbCaregiverTwo_102" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_102" name="rbCaregiverTwo_102" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>103. Involvement  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_103" name="rbCaregiverTwo_103" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_103" name="rbCaregiverTwo_103" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_103" name="rbCaregiverTwo_103" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_103" name="rbCaregiverTwo_103" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_103" name="rbCaregiverTwo_103" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>104. Knowledge  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_104" name="rbCaregiverTwo_104" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_104" name="rbCaregiverTwo_104" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_104" name="rbCaregiverTwo_104" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_104" name="rbCaregiverTwo_104" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_104" name="rbCaregiverTwo_104" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>105. Organization  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_105" name="rbCaregiverTwo_105" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_105" name="rbCaregiverTwo_105" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_105" name="rbCaregiverTwo_105" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_105" name="rbCaregiverTwo_105" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_105" name="rbCaregiverTwo_105" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>106. Resources  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_106" name="rbCaregiverTwo_106" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_106" name="rbCaregiverTwo_106" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_106" name="rbCaregiverTwo_106" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_106" name="rbCaregiverTwo_106" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_106" name="rbCaregiverTwo_106" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>107. Residential Stability  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_107" name="rbCaregiverTwo_107" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_107" name="rbCaregiverTwo_107" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_107" name="rbCaregiverTwo_107" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_107" name="rbCaregiverTwo_107" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_107" name="rbCaregiverTwo_107" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>108. Safety  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_108" name="rbCaregiverTwo_108" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_108" name="rbCaregiverTwo_108" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_108" name="rbCaregiverTwo_108" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_108" name="rbCaregiverTwo_108" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_108" name="rbCaregiverTwo_108" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr >
                        <td className='w-625'>109. Marital/Partner Violence  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_109" name="rbCaregiverTwo_109" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_109" name="rbCaregiverTwo_109" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_109" name="rbCaregiverTwo_109" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_109" name="rbCaregiverTwo_109" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_109" name="rbCaregiverTwo_109" className='add-only' value="Na" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-625'>110. Posttraumatic Reactions  </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo0_110" name="rbCaregiverTwo_110" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo1_110" name="rbCaregiverTwo_110" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo2_110" name="rbCaregiverTwo_110" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwo3_110" name="rbCaregiverTwo_110" className='add-only' value="3" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCaregiverTwoNa_110" name="rbCaregiverTwo_110" className='add-only' value="Na" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>COMPLETED BY:</strong>(Please include credentials after your name)
                </p>
                <table>
                    <tr>
                        <td className='w-500 signature'>&nbsp;</td>
                        <td className='w-250 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Assessor Signature:</td>
                        <td className='small'>Date:</td>
                    </tr>
                    <tr>
                        <td className='w-500 signature'>&nbsp;</td>
                        <td className='w-250 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Assessor Print Name:</td>
                        <td className='small'>Date:</td>
                    </tr>
                </table>
                <p>
                    <strong>REVIEWED BY (If Applicable):</strong>(Please include credentials after your name)
                </p>
                <table>
                    <tr>
                        <td className='w-500 signature'>&nbsp;</td>
                        <td className='w-250 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Licensed Professional Signature:</td>
                        <td className='small'>Date:</td>
                    </tr>
                    <tr>
                        <td className='w-500 signature'>&nbsp;</td>
                        <td className='w-250 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Licensed Professional Print Name:</td>
                        <td className='small'>Date:</td>
                    </tr>
                </table>




            </div>
        </form >

    )
}